import { UrlValidator } from '@q6cyber/js-validators';

export const isUrlCommonValidation = (val: string): boolean => {
  return UrlValidator.isURL(val);
};

export const decimalLimitValidation = (
  val: number | string,
  limit: number
): boolean => {
  const formattedVal = val.toString().replace(',', '.');
  const [, decimalPart] = formattedVal.split('.');
  return !decimalPart || decimalPart.length <= limit;
};

export const phoneValidation = (val: string): boolean => {
  const result = /^\+?\(?\d{1,10}\)?[-. ]?\d{1,10}[-. ]?\d{1,10}$/.test(val);
  return result;
};
